const Telegram = ({ width = '24px', height = '24px' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height}>
      <path
        d="M4.1 11.6c4.3-1.84 7.16-3.05 8.6-3.63C16.77 6.3 17.62 6 18.18 6c.12 0 .4.03.57.17a.6.6 0 01.2.39c.03.11.05.37.03.57-.22 2.28-1.18 7.82-1.67 10.38-.2 1.09-.61 1.45-1 1.48-.86.08-1.5-.55-2.34-1.08-1.3-.84-2.03-1.36-3.29-2.17-1.45-.94-.5-1.45.32-2.3.22-.22 3.99-3.58 4.06-3.89.01-.03.02-.18-.07-.25-.08-.08-.21-.05-.3-.03-.13.03-2.2 1.37-6.22 4.03-.58.4-1.12.58-1.6.57-.52 0-1.53-.29-2.28-.53-.93-.3-1.66-.45-1.6-.95.04-.26.4-.52 1.1-.8z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export default Telegram;
